// src/pages/Signup.jsx
import React from 'react';
import SignupForm from '../components/auth/SignupForm';

const Signup = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-md mx-auto bg-white shadow-md rounded-lg overflow-hidden">
          <div className="bg-gradient-to-r from-blue-600 to-indigo-800 px-6 py-8 text-white text-center">
            <h1 className="text-3xl font-bold">Create an Account</h1>
            <p className="mt-2">Join Tantravani and access our services</p>
          </div>
          
          <div className="p-6">
            <SignupForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;